export default __webpack_public_path__ + "static/media/threebigcards_beauty_3.264f94f0.png";